<template>
    <div class="col-md-6 col-sm-6">
        <article class="blog_item">
            <div class="row">
                <div class="col-lg-5 col-md-12">
                    <figure>
                        <a href="blog-post.html" class="hover_effect h_blue h_link"><img src="/assets/images/blog/latest_news1.jpg" class="img-responsive" alt="Image"></a>
                    </figure>
                </div>
                <div class="col-lg-7 col-md-12">
                    <div class="main">
                        <h3><a href="blog-post.html">Live your myth in Greece</a></h3>
                        <p>Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore...</p>
                        <a href="blog-post.html" class="button btn_xs btn_blue">Read More</a>
                        <div class="info">
                            <i class="fa fa-user" aria-hidden="true"></i><a href="#">JOHN DOE</a>
                            <i class="fa fa-calendar" aria-hidden="true"></i><a href="#">AUGUST 13, 2015</a>
                            <i class="fa fa-comment-o" aria-hidden="true"></i><a href="#">4 COMMENTS</a>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
    export default {

    };
</script>


// WEBPACK FOOTER //
// Item.vue?5eb3b1e8